var map = {
	"./randomimage (1).png": "02cb",
	"./randomimage (2).png": "cef2",
	"./randomimage (3).png": "4938",
	"./randomimage (4).png": "e651",
	"./randomimage (5).png": "5d91",
	"./randomimage (6).png": "c512"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4126";